import { render } from "./IconSettings.vue?vue&type=template&id=288f699b"
import script from "./IconSettings.vue?vue&type=script&lang=js"
export * from "./IconSettings.vue?vue&type=script&lang=js"
script.render = render

export default script